export class FacePercentageItem {

    public blur_percentage: number
    public face_angle_diff: number
    public face_height: number
    public face_percentage: number
    public face_width: number
    public face_x: number
    public face_y: number
    public image_height: number
    public image_width: number
    public left_eye_ratio: number
    public right_eye_ratio: number
    public face_angle_l_diff: number
    public face_angle_r_diff: number
    public nose_x: number
    public nose_y: number
    public chin_x: number
    public chin_y: number

    public static zeros() {
        return new FacePercentageItem(
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0
        )
    }

    constructor(
        blur_percentage: number,
        face_angle_diff: number,
        face_height: number,
        face_percentage: number,
        face_width: number,
        face_x: number,
        face_y: number,
        image_height: number,
        image_width: number,
        left_eye_ratio: number,
        right_eye_ratio: number,
        face_angle_l_diff: number,
        face_angle_r_diff: number,
        nose_x: number,
        nose_y: number,
        chin_x: number,
        chin_y: number,
    ) {

        this.blur_percentage = blur_percentage
        this.face_angle_diff = face_angle_diff
        this.face_height = face_height
        this.face_percentage = face_percentage
        this.face_width = face_width
        this.face_x = face_x
        this.face_y = face_y
        this.image_height = image_height
        this.image_width = image_width
        this.left_eye_ratio = left_eye_ratio
        this.right_eye_ratio = right_eye_ratio
        this.face_angle_l_diff = face_angle_l_diff
        this.face_angle_r_diff = face_angle_r_diff
        this.nose_x = nose_x
        this.nose_y = nose_y
        this.chin_x = chin_x
        this.chin_y = chin_y

    }

}